var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityCameras(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.731 362.731",
    style: {
      enableBackground: "new 0 0 362.731 362.731"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.848,91.82c-37.852-5.338-76.197-8.044-113.969-8.044S52.764,86.482,14.912,91.82c-2.02,0.284-3.664,1.767-4.154,3.745   c-14.344,57.737-14.344,113.867,0,171.597c0.49,1.979,2.135,3.461,4.154,3.746c37.859,5.339,76.209,8.046,113.982,8.046   c0,0-0.002,0,0,0c37.77,0,76.113-2.707,113.953-8.046c2.02-0.285,3.662-1.768,4.154-3.746c14.338-57.717,14.338-113.847,0-171.596   C246.51,93.587,244.867,92.105,242.848,91.82z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.01,91.916c-1.67-0.855-3.68-0.703-5.201,0.393l-80,57.599c-1.445,1.04-2.227,2.77-2.055,4.541   c1.734,17.857,1.736,35.971,0.004,53.836c-0.172,1.77,0.609,3.5,2.055,4.54l79.996,57.599c0.867,0.624,1.893,0.942,2.922,0.942   c0.779,0,1.56-0.182,2.279-0.55c1.67-0.855,2.721-2.574,2.721-4.45V96.366C362.731,94.489,361.68,92.771,360.01,91.916z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCameras);
export default __webpack_public_path__ + "static/media/security-cameras.1ffabff996f408432872068be40decff.svg";
export { ForwardRef as ReactComponent };